// removed by extract-text-webpack-plugin
module.exports = {"content":"content___DV5d3","header":"header___3xWTZ","notes":"notes___1UsSg","errorMsg":"errorMsg____Yt50","successMsg":"successMsg___2roK2"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/NewProject/NewProject.module.css
// module id = 379
// module chunks = 0